import objectAssign from 'object-assign';
import RestHelper from '../utils/RestHelper';

function saveEwiMeterReadingData(formData, endpoint) {
  const params = {
    params: formData
  };
  return RestHelper
    .post(endpoint, params);
}

export const loadDataInitiation = (dispatch, component) => {
  dispatch({
    type: 'INIT_EWIMETERREADING_DATA',
    data: {
      component
    }
  });
};

export const dataRequest = (dispatch, state) => {
  dispatch({
    type: 'SUBMIT_EWIMETERREADING_DATA',
    data: {
      values: state
    }
  });
};

export const dataRequestSuccess = (dispatch, response) => {
  dispatch({
    type: 'SUBMIT_SUCCESSFUL',
    data: {
      response: response.data
    }
  });
};

export const dataRequestError = (dispatch, error) => {
  dispatch({
    type: 'SUBMIT_ERROR',
    data: {
      error
    }
  });
};

export const submitData = (dispatch, data, submitEndpoint) => {
  const resp = saveEwiMeterReadingData(data, submitEndpoint);
  dataRequest(dispatch, data, submitEndpoint);
  return resp
    .then((response) => {
      dataRequestSuccess(dispatch, response);
    }).catch((err) => {
      dataRequestError(dispatch, err);
      console.error(err); // eslint-disable-line no-console
    });
};

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case 'INIT_EWIMETERREADING_DATA': {
      return objectAssign({}, state, action.data);
    }
    case 'SUBMIT_EWIMETERREADING_DATA': {
      return objectAssign({}, state, action.data, { isRequestPending: true });
    }
    case 'SUBMIT_SUCCESSFUL': {
      return objectAssign({}, state, action.data, { isRequestPending: false, isSuccess: true });
    }
    case 'SUBMIT_ERROR': {
      return objectAssign({}, state, action.data, { isRequestPending: false, isSuccess: false });
    }
    default:
      return state;
  }
}
